<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Personales y Familia</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguro de Educacion</h1>
                <p>aseguramos los proyectos educativos desde que son sueños
                Planea desde hoy tu proyecto educativo y el de tus seres queridos.
                </p>
        </div>
        <div class="especialidades-slide">
            <center><h1>Con este seguro educativo podrás:</h1>
            <VueSlickCarousel
                class="slider2"
                ref="slick"
                v-bind="slickOptionsExperiencies"
                :arrows="false">
                <div v-for="(slide, i) in especialidades" :key="i" class="especial">
                    <img :src="slide.image" alt="">
                    <p>{{slide.texto}}</p>
                </div>
            </VueSlickCarousel>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Con el Seguro de Educación estructuras un plan de pagos para construir un capital con el que puedas cubrir los costos del plan educativo
                que quieras asegurar para ti o para tus seres queridos en el futuro
                <br>
                <br>
                El seguro te permite cubrir gastos de matrícula y manutención para estudios primarios, secundarios, no convencionales y universitarios, ya sean
                de pregrado o posgrado. También cubre educación en el exterior como viajes de intercambio.
                <br>
                <br>
                Ten en cuenta que este seguro está libre de cualquier obligación financiera, lo que quiere decir que, si en algún momento dejas de pagarlo,
                no se cancela, no adquieras una deuda y en las fechas acordadas desembolsaremos el capital que hayas adquirido.
                </p>
            </center>
        </div>
        <div class="cubrimos">
            <div class="service" v-for="(service, i) in services" :key="i">
                <div v-if="service.type">
                    <div class="imgbox">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box">
                        <h1>{{service.label}}</h1>
                        <div>
                            <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                            <label for="">Cobertura principal</label>
                        </div>
                        <label for="">Costos de matrícula</label>
                        <div>
                            <div>
                                <p>Con pagos periódicos de cuotas o incluso un solo pago, construyes capital para cubrir los gastos educativos tuyos o de tus seres queridos en el
                                futuro. Funciona de manera sencilla: acumulas el respaldo económico que luego nosotros te desembolsamos para pagar los semestres,
                                en el caso de que sea una universidad. Tu desembolso no pierde valor con el tiempo* y el riesgo financiero lo asumimos nosotros.
                                <br>
                                <br>
                                *Aumenta en enero de cada año de acuerdo al incremento del Índice de Precios al Consumidor (IPC), últimos doce meses decretados
                                por el Dane.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!service.type">
                    <div class="imgbox right">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box2">
                        <h1>{{service.label}}</h1>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="slide-cobertura-opcional">
            <center><h1>Coberturas opcionales</h1></center>
            <VueSlickCarousel
            class="slider"
            ref="slick"
            :autoplay="true"
            :dots="true"
            :arrows="false">
                <div v-for="(slide, i) in coberturaOpcional" :key="i">
                    <div class="cobertura-principal-slide">
                        <div>
                            <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                            <label for="">{{slide.label}}</label>
                        </div>
                       <p v-html="slide.p"></p>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
        <div class="ofrecemos">
            <center><h1>Facilidades que te ofrecemos</h1></center>
            <label for="">Abonos adicionales</label>
            <p>Tendrás la posibilidad de hacer dos tipos de abonos adicionales, programarlo desde el momento que contratas el Seguro o en el momento en
            el que quieres realizar el aporte durante el periodo de pago de primas.</p>
            <label for="">Modificación del periodo de estudio</label>
            <p>Con esta opción puedes:
            <br>
            <br>
            <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Aplazar o adelantar la fecha de inicio de tu período de estudio por un tiempo máximo de un año.
            <br>
            <br>
            <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Ampliar o reducir el periodo de estudio.
            <br>
            <br>
            <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Modificar la periodicidad en la que recibirás el valor del Ingreso adquirido durante el período de estudio.</p>
        </div>
        <div class="texto">
            <center><h1>¿Qué no cubre?</h1></center>
            <center class="box">
                <p>Este seguro no tiene exclusiones para su cobertura principal. Las coberturas opcionales tienen las siguientes exclusiones:
                <br>
                <br>
                <span>Para la cobertura de Vida Escolar y Vida Complemento</span>
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Muerte por suicidio estando o no el tomador del Seguro de Educación en uso de sus facultades mentales dentro de los doce meses
                siguientes a la contratación de esta cobertura o al aumento de los valores asegurados de la misma.
                <br>
                <br>
                <span>Para la cobertura de Incapacidad total y permanente de Vida Escolar y Vida Complemento</span>
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>La conducción de vehículos o artefactos aéreos como parapentes, ultralivianos, paracaídas y planeadores usados en deportes
                extremos, entre otros.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Actos de guerra interior o exterior, revolución, rebelión, sedición, asonada o actos violentos motivados por conmoción social o por
                aplicación de la ley marcial.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Prestación del servicio militar, naval, aéreo o de policía.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Fisión o fusión nuclear o radioactividad.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Enfermedades congénitas o lesiones, defectos físicos y enfermedades originadas, ocurridas o adquiridas antes de la contratación
                de la cobertura, incluso si el tomador del Seguro de Educación no las conocía.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Intento de suicidio o invalidez provocada intencionalmente.
                <br>
                <br>
                </p>
            </center>
        </div>
        <div class="cubrimos">
            <div class="service" v-for="(service, i) in services" :key="i">
                <div v-if="service.type">
                    <div class="imgbox">
                        <img :src="service.img2" alt="">
                    </div>
                    <div class="box">
                        <div>
                            <div>
                                <p><span>Todas las personas que como tú desean construir un patrimonio que te acompañe en el cumplimiento tus metas educativas y en las de tus
                                seres queridos. Este seguro te da la libertad de elegir los beneficiarios, es fácil de adquirir y no requiere evaluación médica o
                                declaración de asegurabilidad.</span>
                                <br>
                                <br>
                                <span>Las coberturas opcionales están disponibles para cualquier interesado que tenga entre 18 y 70 años de edad según las políticas de suscripción
                                de la aseguradora y los criterios de evaluación médica establecidos. Los requisitos para adquirir dichas coberturas opcionales son:</span></p>
                                <br>
                                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Llenar la solicitud.
                                <br>
                                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Cumplir con la edad requerida de acuerdo con las políticas establecidas.
                                <br>
                                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Diligenciar y firmar la declaración de asegurabilidad.
                                <br>
                                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Adjuntar la información médica y financiera requerida.
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!service.type">
                    <div class="imgbox right">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box2">
                        <h1>{{service.label}}</h1>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="texto">
            <center><h1>Tarifa del seguro</h1></center>
            <center class="box">
                <p>El valor será definido de acuerdo con los siguientes factores:
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Edad de los asegurados.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Valor de la renta educativa deseada.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Plazos establecidos para los pagos y los desembolsos de las rentas mensuales.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>El costo mínimo de la cobertura principal es $100 000 mensuales o el equivalente en otras periodicidades.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>En caso de que no pagues la cuota mensual del seguro, SURA no lo cancela y en cualquier momento puedes desatrasarte de lo que
                tienes pendiente. Si no puedes pagar, te entregaremos la renta que hayas logrado acumular.
                </p>
            </center>
        </div>
        <div class="move"><center><img src="@/assets/Seguro-educacion/4.png" alt=""></center></div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'Seguro-Colectivo-salud',
    components: {
        Aliados,
        VueSlickCarousel
    },
    data() {
        return {
            services: [
                {
                    type: true,
                    img: require('@/assets/Seguro-educacion/5.png'),
                    img2: require('@/assets/Seguro-educacion/6.png'),
                    label: '¿Qué cubre?'
                }
            ],
            coberturaPrincipal: [
                {
                    label: 'Infidelidad de empleados',
                    p: 'Se pagara a su empresa cuando sufra pérdidas de dinero, títulos valores u otras propiedades por un acto de infidelidad o falsificación cometido por uno de sus empleados, sea que haya actuado solo o con otras personas.'
                },
                {
                    label: 'Predios',
                    p: 'Se asumen las pérdidas económicas causadas por la destrucción, la desaparición y el hurto de dinero, títulos valores u otras propiedades a manos de terceros en las instalaciones de la empresa.'
                },
                {
                    label: 'Tránsito',
                    p: 'Se reapandara cuando dinero o títulos valores de su empresa sean destruidos o hurtados por un tercero mientras estos estaban siendo movilizados por una persona autorizada por su empresa'
                },
                {
                    label: 'Falsificación de cheques y otros documentos',
                    p: 'Lo indemnizaremos si su empresa sufre pérdidas económicas por los actos de un tercero que falsifica o altera un instrumento financiero.'
                },
                {
                    label: 'Hurto por computador',
                    p: 'Lo acompañaremos en el evento que un tercero ingrese a su sistema de información y modifique, elimine o robe algún dato, y ello le genere pérdidas o afectaciones económicas a su empresa'
                }
            ],
            coberturaOpcional: [
                {
                    label: 'Gastos de manutención',
                    p: 'Podrás programar unos pagos mensuales para cubrir la manutención durante el periodo de estudio en temas como alimentación, vivienda o transporte.'
                },
                {
                    label: 'Plan Vida Escolar',
                    p: 'Si llegas a fallecer o a sufrir una invalidez total o permanente antes de comenzar los desembolsos de la cobertura principal (Renta educativa), te garantizamos que tu ser querido recibirá desembolsos mensuales de dinero que puede utilizar para pagar gastos escolares de su formación preescolar, primaria o secundaria. <br><br> Por ejemplo: si tu plan educativo es para asegurar la universidad de tu hijo y falleces cuando él apenas está en el colegio, nosotros le entregamos un dinero mensual hasta que comience su carrera.'
                },
                {
                    label: 'Plan Vida Complemento',
                    p: 'Si aún no has finalizado el plan de pagos de la cobertura principal (Renta educativa), falleces o sufres una invalidez total o permanente, este plan termina de pagar por ti, garantizando que tus seres queridos tengan acceso a la educación.'
                }
            ],
            slickOptionsExperiencies: {
                'dots': false,
                'arrows': true,
                'focusOnSelect': true,
                'infinite': true,
                'autoplay': true,
                'autoplaySpeed': 3000,
                'speed': 500,
                'slidesToShow': 3,
                'slidesToScroll': 3,
                'touchThreshold': 5,
                'responsive': [
                    {
                        'breakpoint': 1140,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'infinite': true
                        }
                    },
                    {
                        'breakpoint': 680,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'infinite': true
                        }
                    }
                ]
            },
            especialidades: [
                {
                    image: require('@/assets/Seguro-educacion/1.png'),
                    texto: 'Lograr las metas definidas para ti o tus seres queridos.'
                },
                {
                    image: require('@/assets/Seguro-educacion/2.png'),
                    texto: 'Estructurar un plan de pagos para construir un capital para estudio.'
                },
                {
                    image: require('@/assets/Seguro-educacion/3.png'),
                    texto: 'Tener un seguro libre de cualquier obligación financiera.'
                },
                {
                    image: require('@/assets/Seguro-educacion/7.png'),
                    texto: 'Acumular el respaldo económico que te desembolsaremos en la matrícula.'
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>
<style>
    .cobertura-principal-slide > p > span {
        font-weight: bold;
        margin-left: 5em;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 25px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 5px;
        margin-bottom: 15px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
</style>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-bg-personas-familias.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
        width: 60%;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .slider2 {
        width: 70%;
    }
    .especialidades-slide{
        padding-top: 40px;
    }
    .especialidades-slide > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        font-size: 30px;
    }
    .especialidades > div {
        height: 500px;
    }
    .especial img {
        width: 100%;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
    }
    .especial > p {
        font-family: 'JR';
        padding: 10px;
        text-align: left;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
        color: #2d4f98;
    }
    .service {
        padding: 20px 300px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        margin-top: 20px;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 110px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box > div > img {
        width: 70px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .service > div > .box > label {
        font-weight: bold;
        padding: 20px;
    }
    .service > div > .box > div > label {
        font-family: 'JBD';
        color: #65b24a;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box > div > div > p > span{
        color:#65b24a;
        font-family: 'JBD';
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
    .cobertura-principal {
        width: 100%;
        padding: 0px 300px;
    }
    .cobertura-principal > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
    }
    .cobertura-principal > div {
        display: flex;
        margin-bottom: 50px;
    }
    .cobertura-principal > div > center > img {
        width: 200px;
        height: auto;
    }
    .cobertura-principal > div > div {
        padding: 20px;
    }
    .cobertura-principal > div > div > div > img{
        width: 50px;
        margin-right: 20px;
    }
    .cobertura-principal > div > div > div > label{
        font-family: 'JBD';
        color: #65b24a;
        font-size: 20px;
    }
    .cobertura-principal > div > div {
        padding: 25px;
        margin-top: 20px;
        font-family: 'JR';
        -webkit-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        -moz-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
    }
    .cobertura-principal-slide{
        padding: 0px 300px;
    }
    .cobertura-principal-slide > div {
        display: flex;
    }
    .cobertura-principal-slide > div > label {
        color: #65b24a;
        font-family: 'JBD';
        font-size: 20px;
    }
    .cobertura-principal-slide > div > img {
        width: 50px;
    }
    .cobertura-principal-slide > p {
        font-family: 'JR';
        margin-top: 10px;
        margin-bottom: 60px;
    }
    .slide-cobertura-opcional > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .ofrecemos {
        padding: 50px 300px;
    }
    .ofrecemos > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
    }
    .ofrecemos > label {
        color: #65b24a;
        font-family: 'JBD';
    }
    .opcionales {
        padding: 50px 300px;
        font-family: 'JR';
    }
    .opcionales > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-bottom: 20px;
    }
    .opcionales > .opcional > .subopcional {
        padding-left: 50px;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    .move > center > img {
        margin-top: 30px;
        width: 800px;
    }
    @media (max-width: 1600px) {
        .slider2 {
            width: 60%;
        }
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .slider2 {
            width: 65%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .service {
            padding: 20px 150px;
            width: 100%;
        }
        .slider2 {
            width: 70%;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal-slide{
            padding: 0px 200px;
        }
        .opcionales {
            padding: 50px 200px;
        }
        .ofrecemos {
            padding: 50px 200px;
        }
        .slider2 {
            width: 75%;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
        .slider2 {
            width: 80%;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            width: 100%;
            padding: 10px;
            text-align: center;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 100px;
        }
        .cobertura-principal-slide{
            padding: 0px 100px;
        }
        .opcionales {
            padding: 50px 100px;
        }
        .ofrecemos {
            padding: 50px 100px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
        .move > center > img {
            width: 700px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .cobertura-principal > div {
            display: block;
        }
        .move > center > img {
            width: 600px;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
        .cobertura-principal {
            padding: 10px 50px;
        }
        .cobertura-principal-slide {
            padding: 0px 50px;
        }
        .opcionales {
            padding: 50px 50px;
        }
        .ofrecemos {
            padding: 50px 50px;
        }
        .move > center > img {
            width: 500px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
        .move > center > img {
            width: 400px;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
        .slide-cobertura-opcional > center > h1 {
            font-size: 30px;
        }
        .cobertura-principal > center > h1{
            font-size: 30px;
        }
        .opcionales > center > h1 {
            font-size: 30px;
        }
        .ofrecemos > center > h1 {
            font-size: 30px;
        }
        .move > center > img {
            width: 300px;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
        .move > center > img {
            width: 250px;
        }
        .especial img {
            width: 240px;
        }
        .cobertura-principal > div > div {
            padding: 20px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosPersonas/SeguroEducacion.vue